<!-- 兼职 -->
<template>
  <div class="sponsor">
    <v-head></v-head>
    <div class="container">
      <!-- banner -->
      <div class="sponsor-banner">
        <el-carousel trigger="click" :interval="5000" arrow="never" height="100%">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <div class="banner-img" :style="'background-image:url(' + item.image_url + ')'"></div>
            <div class="help-banner-zz"></div>
            <div class="sponsor-banner-con">
              <div class="sponsor-banner-title">{{ item.title }}</div>
              <div class="sponsor-banner-line">—</div>
              <div class="sponsor-banner-message">{{ item.description }}</div>
              <div class="sponsor-banner-more">
                <a href="javascript:void(0);">
                  <el-button size="small">
                    {{ item.button_name }}
                    <i class="el-icon-arrow-right"></i>
                  </el-button>
                </a>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
        <!-- <div class="sponsor-banner-img">
          <div class="sponsor-banner-bg" :style="'background-image:url(' + img + ')'"></div>
          <div class="sponsor-banner-con">
            <div class="sponsor-banner-title">校园兼职</div>
            <div class="sponsor-banner-line">—</div>
            <div
              class="sponsor-banner-message"
            >校园兼职岗位职责频道为各位用户提供关于校园兼职工作职责及任职要求，此外还介绍了关于校园兼职岗位工资及学历分布情况以及更多与校园兼职岗位相关的其他信息</div>
            <div class="sponsor-banner-more">
              <el-button size="small" @click="toDetails()">
                了解更多
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </div>
        </div>-->
      </div>
      <!-- 兼职展示 -->
      <div class="sponsor-activity">
        <!-- 兼职切换nav -->
        <el-tabs class="sponsor-activity-nav" v-model="activityed" type="border-card">
          <el-tab-pane
            v-for="(item,index) of activityList"
            :key="index"
            :label="item.label"
            :name="item.label"
          >
            <div class="sponsor-activity-con">
              <div class="activity-con-title">{{ item.label }}</div>
              <div class="activity-con-message">{{ item.message }}</div>
              <div class="activity-con-cut">
                <div
                  class="activity-cut-prev"
                  :class="activityed === activityList[0].label?'activity-disabled':''"
                  @click="prev()"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div
                  class="activity-cut-next"
                  :class="activityed === activityList[activityList.length-1].label?'activity-disabled':''"
                  @click="next()"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 兼职案例 -->
      <div class="sponsor-case" style="background:#333333">
        <div id="stu-list-wrap">
          <three-info></three-info>
        </div>
      </div>
      <!-- 搜索位置 -->
      <div class="search-box">
        <div class="case-title">
          <span class="case-title-t">全国高校大学生人才库</span>
          <span class="case-title-b">基于到梦空间数据进行定向人才筛选，富维度标签精准匹配</span>
        </div>
        <!-- 搜索 -->
        <div class="case-search">
          <div class="case-search-box">
            <!-- 1 -->
            <div class="case-search-item">
              <div class="case-search-item-top">
                <el-input
                  placeholder="请选择目标城市"
                  v-model="searchModel1"
                  size="small"
                  class="input-with-select"
                  @keyup.enter.native="tipswords1()"
                ></el-input>
                <i class="el-icon-finished" @click="tipswords1()"></i>
              </div>
              <div class="case-search-item-bottom">
                <span
                  class="search-item-icon"
                  v-for="(item,index) of fastList.area"
                  :key="index"
                  :class="checked1 == index?'search_checked':''"
                  @click="fastSeach1(item.name,index)"
                >{{ item.value }}</span>
                <!-- <span class="search-item-icon search-item-icon-2">北京</span>
                <span class="search-item-icon search-item-icon-2">上海</span>
                <span class="search-item-icon search-item-icon-2">深圳</span>-->
              </div>
            </div>
            <!-- 2 -->
            <div class="case-search-item">
              <div class="case-search-item-top">
                <el-input
                  placeholder="请选择毕业院校"
                  v-model="searchModel2"
                  size="small"
                  class="input-with-select"
                  @keyup.enter.native="tipswords2()"
                ></el-input>
                <i class="el-icon-finished" @click="tipswords2()"></i>
              </div>
              <div class="case-search-item-bottom">
                <span
                  class="search-item-icon"
                  v-for="(item,index) of fastList.school"
                  :key="index"
                  :class="checked2 == index?'search_checked':''"
                  @click="fastSeach2(item.name,index)"
                >{{ item.value }}</span>
              </div>
            </div>
            <!-- 3 -->
            <div class="case-search-item">
              <div class="case-search-item-top">
                <el-input
                  placeholder="请选择招聘方向"
                  v-model="searchModel3"
                  size="small"
                  class="input-with-select"
                  @keyup.enter.native="tipswords3()"
                ></el-input>
                <i class="el-icon-finished" @click="tipswords3()"></i>
              </div>
              <div class="case-search-item-bottom">
                <span
                  class="search-item-icon"
                  v-for="(item,index) of fastList.zp"
                  :key="index"
                  :class="checked3 == index?'search_checked':''"
                  @click="fastSeach3(item.name,index)"
                >{{ item.value }}</span>
              </div>
            </div>
            <!-- 4 -->
            <div class="case-search-item">
              <div class="case-search-item-top">
                <el-input
                  placeholder="请选择用工类型"
                  v-model="searchModel4"
                  size="small"
                  class="input-with-select"
                  @keyup.enter.native="tipswords4()"
                ></el-input>
                <i class="el-icon-finished" @click="tipswords4()"></i>
              </div>
              <div class="case-search-item-bottom">
                <span
                  class="search-item-icon"
                  v-for="(item,index) of fastList.status"
                  :key="index"
                  :class="checked4 == index?'search_checked':''"
                  @click="fastSeach4(item.name,index)"
                >{{ item.value }}</span>
              </div>
            </div>
            <!-- 5 -->
            <div class="case-search-item">
              <div class="case-search-item-top">
                <el-input
                  placeholder="请选择性别"
                  v-model="searchModel5"
                  size="small"
                  class="input-with-select"
                  @keyup.enter.native="tipswords5()"
                ></el-input>
                <i class="el-icon-finished" @click="tipswords5()"></i>
              </div>
              <div class="case-search-item-bottom">
                <span
                  class="search-item-icon"
                  v-for="(item,index) of fastList.sex"
                  :key="index"
                  :class="checked5 == index?'search_checked':''"
                  @click="fastSeach5(item.name,index)"
                >{{ item.value }}</span>
              </div>
            </div>
            <!-- 6 -->
            <div class="case-search-item">
              <div class="case-search-item-top">
                <el-input
                  placeholder="请选择必填资料"
                  v-model="searchModel6"
                  size="small"
                  class="input-with-select"
                  @keyup.enter.native="tipswords6()"
                ></el-input>
                <i class="el-icon-finished" @click="tipswords6()"></i>
              </div>
              <div class="case-search-item-bottom">
                <span
                  class="search-item-icon"
                  v-for="(item,index) of fastList.dataSure"
                  :key="index"
                  :class="checked6 == index?'search_checked':''"
                  @click="fastSeach6(item.name,index)"
                >{{ item.value }}</span>
              </div>
            </div>
            <!-- 7搜索 -->
            <div class="case-search-item"></div>
            <div class="case-search-item">
              <div class="case-search-item-top">
                <el-button
                  size="small"
                  class="input-with-search-button"
                  type="primary"
                  round
                  @click="tipswordsSearch()"
                >立即筛选</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <v-footer></v-footer>
    <!-- 弹窗提示  -->
    <transition name="fade">
      <div class="modelBox" v-if="show">
        <div class="model_text">您暂未获得查阅权限</div>
      </div>
    </transition>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import vRelation from '@/components/relation/relation.vue'
import img1 from '@/assets/img/icon-parttime/jianzhi1.png'
import img2 from '@/assets/img/icon-parttime/jianzhi2.png'
import img3 from '@/assets/img/icon-parttime/jianzhi3.png'
import threeInfo from '@/components/threeinfo/threeInfo'
import {
  Carousel,
  CarouselItem,
  Button,
  Tabs,
  TabPane,
  Input
} from 'element-ui'
export default {
  data () {
    return {
      show: false, // 临时控制弹窗显隐参数
      activityed: '二课成绩单',
      searchModel1: '',
      searchModel2: '',
      searchModel3: '',
      searchModel4: '',
      searchModel5: '',
      searchModel6: '',
      checked1: '-1',
      checked2: '-1',
      checked3: '-1',
      checked4: '-1',
      checked5: '-1',
      checked6: '-1',
      fastList: {
        // 地区
        area: [{
          name: '北京市',
          value: '北'
        }, {
          name: '上海市',
          value: '上'
        }, {
          name: '深圳市',
          value: '深'
        }],
        // 院校
        school: [{
          name: '985/211类院校',
          value: '顶'
        }, {
          name: '其他综合类院校',
          value: '综'
        }, {
          name: '高职类院校',
          value: '高'
        }],
        // 招聘方向
        zp: [{
          name: '自媒体方向',
          value: '自'
        }, {
          name: 'IT综合类方向',
          value: 'IT'
        }, {
          name: '销售类方向',
          value: '销'
        }],
        // 用工类型
        status: [{
          name: '全职类型',
          value: '全'
        }, {
          name: '兼职或灵活用工类型',
          value: '兼'
        }, {
          name: '实习类型',
          value: '实'
        }],
        // 性别
        sex: [{
          name: '男生或女生',
          value: '通'
        }, {
          name: '男生',
          value: '男'
        }, {
          name: '女生',
          value: '女'
        }],
        // 必填资料
        dataSure: [{
          name: '已上传视频简历',
          value: '视'
        }, {
          name: '已上传音频作品',
          value: '音'
        }, {
          name: '已上传个人生活照片',
          value: '图'
        }]
      },
      activityList: [{
        label: '二课成绩单',
        message: '科技让企业与人才更快相遇，二课成绩单真实记录学生在校活动以及社团学生任职情况，企业从此“火眼金睛”'
      }, {
        label: '视频简历',
        message: '在校期间所有视频类作品从过程到结果全程记录学生成长过程，视频简历免去异地面试苦恼，在线全方位了解学生，让面试更“近”一步'
      }, {
        label: '线上宣讲会',
        message: '告别传统线下宣讲，免去场地以及现场招募，随时举办，一键推送，精准学生人群关注'
      }, {
        label: '在线招聘',
        message: '涵盖兼职、实习、全职招聘800万人才，精准触达全网学生用户精准匹配快速招聘到岗'
      }, {
        label: '定制PRO',
        message: '以客户需求为导向，以项目为建制，提供精准高效“一站式”定制化招聘服务'
      }],
      bannerList: [{
        button_name: '了解更多',
        description: '响应国家人才强国战略，合理应用“第二课堂成绩单制度”，为促进大学生就业，更好地服务提供用人岗位的校招企业与招聘平台，有效提供桥梁工具，以保证学生信息的真实可查、全面展示、精准匹配，为用人单位选人用人提供重要参考功能。',
        id: 29,
        image_url: 'https://testpic.nauac.com/20190821/b4cd52b4e9ed48b0ada316c7472d1591.png',
        title: '校招伴侣',
        url: 'https://testpic.nauac.com/20190821/b4cd52b4e9ed48b0ada316c7472d1591.png'
      }],
      caseList: [],
      prevClick: true,
      nextClick: true
    }
  },
  components: {
    'el-carousel': Carousel,
    'el-carousel-item': CarouselItem,
    'v-head': vHead,
    'v-footer': vFooter,
    'el-button': Button,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'v-relation': vRelation,
    'three-info': threeInfo,
    'el-input': Input
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    // 提示弹窗控制
    toops () {
      this.show = true
      window.setTimeout(() => {
        this.show = false
      }, 1200)
    },
    init () {
      // 临时
      this.caseList = [{
        picUrl: img1,
        sort: 1,
        sponsorId: 0,
        title: '文都教育考研校园代理'
      }, {
        picUrl: img2,
        sort: 1,
        sponsorId: 1,
        title: '专业英语翻译实习生'
      }, {
        picUrl: img3,
        sort: 1,
        sponsorId: 2,
        title: '星巴克直招六日学生兼职服务员'
      }]

      // this.$http({
      //   method: 'post',
      //   url: '/sponsor/case/list'
      // }).then(res => {
      //   if (res.code === 100) {
      //     this.caseList = res.result.list
      //   }
      // }).catch(error => {
      //   console.log(error)
      //   return false
      // })
    },
    prev () {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === 0) {
            return
          } else {
            this.activityed = this.activityList[i - 1].label
            return
          }
        }
      }
    },
    next (e) {
      for (let i = 0; i < this.activityList.length; i++) {
        if (this.activityList[i].label === this.activityed) {
          if (i === (this.activityList.length - 1)) {
            return
          } else {
            this.activityed = this.activityList[i + 1].label
            return
          }
        }
      }
    },
    toSponsorDetailes (id, title) {
      this.$router.push({
        path: '/parttimedetail',
        query: {
          id: id,
          title: title
        }
      })
    },
    // 人才库模块搜索事件
    tipswords1 () {
      this.toops()
    },
    tipswords2 () {
      this.toops()
    },
    tipswords3 () {
      this.toops()
    },
    tipswords4 () {
      this.toops()
    },
    tipswords5 () {
      this.toops()
    },
    tipswords6 () {
      this.toops()
    },
    tipswordsSearch () {
      this.toops()
    },
    // 点击搜索框下面原点快速搜索点击事件
    fastSeach1 (val, index) {
      if (this.checked1 === index) {
        this.checked1 = '-1'
        this.searchModel1 = ''
      } else {
        this.checked1 = index
        this.searchModel1 = val
      }
    },
    fastSeach2 (val, index) {
      if (this.checked2 === index) {
        this.checked2 = '-1'
        this.searchModel2 = ''
      } else {
        this.checked2 = index
        this.searchModel2 = val
      }
    },
    fastSeach3 (val, index) {
      if (this.checked3 === index) {
        this.checked3 = '-1'
        this.searchModel3 = ''
      } else {
        this.checked3 = index
        this.searchModel3 = val
      }
    },
    fastSeach4 (val, index) {
      if (this.checked4 === index) {
        this.checked4 = '-1'
        this.searchModel4 = ''
      } else {
        this.checked4 = index
        this.searchModel4 = val
      }
    },
    fastSeach5 (val, index) {
      if (this.checked5 === index) {
        this.checked5 = '-1'
        this.searchModel5 = ''
      } else {
        this.checked5 = index
        this.searchModel5 = val
      }
    },
    fastSeach6 (val, index) {
      if (this.checked6 === index) {
        this.checked6 = '-1'
        this.searchModel6 = ''
      } else {
        this.checked6 = index
        this.searchModel6 = val
      }
    }
  }
}
</script>
<style src='../parttime/parttime_active.scss' lang="scss"></style>
<style src='../parttime/parttime.scss' lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/parttime/parttime.vue